import { useMemo } from "react";
import AppConfig from "util/AppConfig";
const useCustomLogo = (theme) => useMemo(() => {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.logo) == null ? void 0 : _d[theme];
}, [theme]);
export default useCustomLogo;
